import { useContext, useEffect } from "react"
import ModelElements from "../ModelElements"
import { ProductModelProps } from "../ModelViewerProduct"
import ProductTextureContext from "../_contexts/ProductTextureContext"
import useGLB from "../_hooks/useGLB"
import { FindMaterial } from "../../Common/Utils/ThreeTools"

export default function VeganLeatherPlacemat(props: ProductModelProps) {
    const url = new URL('@resources/3d-models/glb/vegan-leather-placemat.glb', import.meta.url);
    const model = useGLB(url)
    const elements = model.scene.children
    const [productTexture] = useContext(ProductTextureContext)

    // Apply lab texture
    useEffect(() => {
        if (!elements) return
      
        let mat = FindMaterial('design', elements)
        if (!mat) return
        mat.map = productTexture
        mat.map.flipY = false
        mat.map.needsUpdate = true
        mat.normalScale.x = 8.0
        mat.normalScale.y = 8.0
    }, [productTexture, elements])
    
    return <ModelElements scene={model.scene}/>
}